import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-info-circle",
  "use": "foquz-icon-vue-info-circle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol preserveAspectRatio=\"none\" overflow=\"visible\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-info-circle\"><path d=\"M7 4.009V4m0 3v3m0 3A6 6 0 107 1a6 6 0 000 12z\" stroke=\"var(--stroke-0, #667799)\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol